var _path, _path2, _ellipse, _ellipse2, _ellipse3, _path3, _path4, _polygon, _path5, _polygon2, _path6, _path7, _path8, _path9, _polygon3, _polygon4, _polygon5, _circle, _path10, _path11, _path12, _circle2, _circle3, _path13, _path14, _path15, _path16, _path17;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInProgress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 740.10323,
    height: 574.31553,
    viewBox: "0 0 740.10323 574.31553",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M717.41322,0h-647.62a22.71737,22.71737,0,0,0-22.69,22.69V417.31a22.71737,22.71737,0,0,0,22.69,22.69h647.62a22.71738,22.71738,0,0,0,22.69-22.69V22.69A22.71738,22.71738,0,0,0,717.41322,0Zm20.69,417.31a20.69,20.69,0,0,1-20.69,20.69h-647.62a20.69,20.69,0,0,1-20.69-20.69V157.67554A155.67554,155.67554,0,0,1,204.77877,2H717.41322a20.69,20.69,0,0,1,20.69,20.69Z",
    fill: "#3f3d56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M678.92225,335.731h-296.63A11.6277,11.6277,0,0,1,370.678,324.11672V227.78153a11.6277,11.6277,0,0,1,11.61427-11.61428h296.63a11.62771,11.62771,0,0,1,11.61427,11.61428v96.33519A11.62771,11.62771,0,0,1,678.92225,335.731Z",
    fill: "#e6e6e6"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 216.40538,
    cy: 54.87291,
    rx: 8.64192,
    ry: 8.83451,
    fill: "#3f3d56"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 186.55149,
    cy: 54.87291,
    rx: 8.64192,
    ry: 8.83451,
    fill: "#3f3d56"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 156.6976,
    cy: 54.87291,
    rx: 8.64192,
    ry: 8.83451,
    fill: "#3f3d56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M498.77559,145.10878H377.91041a7.52,7.52,0,0,1,0-15.04008H498.77559a7.52,7.52,0,0,1,0,15.04008Z",
    fill: "#e6e6e6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M593.09919,170.56122H377.91041a7.52,7.52,0,0,1,0-15.04008H593.09919a7.52,7.52,0,1,1,0,15.04008Z",
    fill: "#e6e6e6"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "162.313 563.077 172.402 563.076 177.201 524.161 162.311 524.162 162.313 563.077",
    fill: "#ffb6b6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M161.95749,573.60189l31.02493-.00119v-.39231a12.07642,12.07642,0,0,0-12.07576-12.07558h-.00075l-5.66709-4.29933-10.57354,4.3-2.70828.00006Z",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "103.992 563.077 114.081 563.076 118.88 524.161 103.99 524.162 103.992 563.077",
    fill: "#ffb6b6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M103.63647,573.60189l31.02493-.00119v-.39231a12.07642,12.07642,0,0,0-12.07577-12.07558h-.00074l-5.66709-4.29933-10.57354,4.3-2.70828.00006Z",
    fill: "#2f2e41"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M230.27163,304.69721l-34.37412-32.23668,9.3102-15.59609L239.10887,295.633a9.85119,9.85119,0,1,1-8.83724,9.06424Z",
    fill: "#ffb6b6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M94.12116,351.62951s-4.26739,38.40652,4.97863,74.67935l-3.48243,17.53439,7.74982,100.53012h18.81124l13.1942-165.71705,24.6299,165.71705h19.75769l-2.42491-91.03769,8.55159-87.48153-3.573-19.9145Z",
    fill: "#2f2e41"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M146.10323,202h-42l-7.06341,17.95826,1.70435,141.98411s83.21414,0,88.904-5.68986l-17.7808-61.87718-6.40109-78.94675Z",
    fill: "#f39c12"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "169.156 214.717 199.028 246.723 209.696 253.835 212.541 263.081 200.45 283.707 186.937 278.728 182.67 263.081 157.594 242.581 154.931 209.739 169.156 214.717",
    fill: "#2f2e41"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "142.188 203.016 147.103 224 153.865 298.998 163.111 355.897 189.785 355.897 173.779 294.02 167.378 214.362 146.041 201.56 142.188 203.016",
    fill: "#2f2e41"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "107.931 203.016 115.458 227.164 127.549 306.822 109.057 363.72 91.103 364 86.431 346.349 96.966 301.132 82.741 214.362 104.078 201.56 107.931 203.016",
    fill: "#2f2e41"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 123.47208,
    cy: 169.43092,
    r: 25.45799,
    fill: "#ffb6b6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M108.78531,182.03328s-1.22281,1.85466,1.138,9.7241l-10.82355-8.68985-1.18392-9.54286s-5.50861-19.67361,13.37806-29.11695c0,0,16.52583-8.65639,32.26473,3.93472,0,0,6.29555.78695,5.50861,1.57389s-4.72167,3.14778-.787,2.36084,6.29556-4.72167,6.29556-2.36084-7.0825,7.86945-7.0825,7.86945,2.7543,7.476-16.13237-2.75431v0a21.108,21.108,0,0,1-10.86372,11.37669l.60594.59183h0l-4.69416,10.06592S111.53962,170.62259,108.78531,182.03328Z",
    fill: "#2f2e41"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M110.78336,380.68836l85.53226-192.85677a8.27,8.27,0,0,1,10.90006-4.20219l62.63323,27.77793a8.27,8.27,0,0,1,4.20219,10.90006L188.51884,415.16417a8.27,8.27,0,0,1-10.90007,4.20219l-62.63322-27.77793A8.27,8.27,0,0,1,110.78336,380.68836Z",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M110.78336,380.68836l85.53226-192.85677a8.27,8.27,0,0,1,10.90006-4.20219l62.63323,27.77793a8.27,8.27,0,0,1,4.20219,10.90006L188.51884,415.16417a8.27,8.27,0,0,1-10.90007,4.20219l-62.63322-27.77793A8.27,8.27,0,0,1,110.78336,380.68836Zm161.93893-158.9703a6.81447,6.81447,0,0,0-3.46271-8.98192l-62.63323-27.77793a6.81447,6.81447,0,0,0-8.98192,3.46271L112.11217,381.27769a6.81447,6.81447,0,0,0,3.46271,8.98193l62.63322,27.77793a6.81448,6.81448,0,0,0,8.98193-3.46271Z",
    fill: "#3f3d56"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 204.27831,
    cy: 269.82564,
    r: 32.00544,
    fill: "#ccc"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 188.70759,
    cy: 304.93424,
    r: 32.00544,
    fill: "#3f3d56"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M160.16127,369.3a32.00544,32.00544,0,1,1,25.9512-58.51434c16.15829,7.16622,33.87683,43.92154,16.28157,42.23276C182.24462,351.08452,176.31956,376.46624,160.16127,369.3Z",
    fill: "#f39c12"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M117.11263,350.313,92.10323,288l20,4,16.691,53.43474a9.8512,9.8512,0,1,1-11.68159,4.87829Z",
    fill: "#ffb6b6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M76.61773,229.56329c-1.45581,16.06283,1.55945,30.16651,6.96727,43.22182l.69454,11.61228,5.55966,7.9166,23.70719,3.09527,4.35283-13.72777-9.74411-12.96514-.81922-32.37791-24.3118-22.24116Z",
    fill: "#2f2e41"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M54.25887,556.98257a2.26935,2.26935,0,0,1-1.64468-3.93333l.1555-.61819q-.03072-.07427-.06179-.14839a6.09416,6.09416,0,0,0-11.24138.04177c-1.83859,4.42817-4.17943,8.86388-4.7558,13.54594a18.029,18.029,0,0,0,.31649,6.20047,72.28138,72.28138,0,0,1-6.57516-30.02077,69.76621,69.76621,0,0,1,.43275-7.783q.3585-3.17781.99471-6.31034a73.11883,73.11883,0,0,1,14.50012-30.98961,19.45908,19.45908,0,0,0,8.093-8.39652,14.84349,14.84349,0,0,0,1.34991-4.05618c-.394.05168-1.48556-5.94866-1.1884-6.3168-.54906-.83317-1.53178-1.24733-2.13144-2.06034-2.98232-4.04341-7.0912-3.33741-9.23621,2.15726-4.58224,2.31267-4.62659,6.14806-1.815,9.83683,1.78878,2.34682,2.03456,5.52233,3.60409,8.03479-.16151.2067-.32945.40695-.49091.61366a73.59073,73.59073,0,0,0-7.681,12.16859,30.59244,30.59244,0,0,0-1.8264-14.20959c-1.74819-4.21731-5.02491-7.76915-7.91045-11.415a6.27922,6.27922,0,0,0-11.184,3.08332q-.00887.08064-.01731.1612.6429.36267,1.25863.76992A3.0782,3.0782,0,0,1,15.963,492.94l-.06277.00968a30.62792,30.62792,0,0,0,.80734,4.57937c-3.70179,14.31579,4.29011,19.5299,15.70147,19.76413.25191.12916.49739.25832.74929.38108a75.11456,75.11456,0,0,0-4.04326,19.02779,71.24345,71.24345,0,0,0,.05167,11.50323l-.01938-.13562a18.82562,18.82562,0,0,0-6.42661-10.87028c-4.9456-4.06264-11.93282-5.55869-17.26825-8.82425a3.533,3.533,0,0,0-5.41122,3.43708l.02182.14261a20.67471,20.67471,0,0,1,2.31872,1.11733q.64288.36276,1.25863.76991a3.07824,3.07824,0,0,1-1.24107,5.60181l-.06282.00964c-.04519.00646-.084.013-.12911.01944A30.65462,30.65462,0,0,0,7.846,548.30221c2.31464,12.49713,12.256,13.68283,22.89023,10.04354h.00648a75.09184,75.09184,0,0,0,5.0444,14.7262H53.80731c.06464-.20021.12274-.40692.1809-.60717a20.47435,20.47435,0,0,1-4.9863-.297c1.337-1.64059,2.674-3.29409,4.011-4.93462a1.11929,1.11929,0,0,0,.084-.0969c.67817-.8396,1.36282-1.67282,2.041-2.51245l.00036-.001a29.99051,29.99051,0,0,0-.87876-7.63985Z",
    fill: "#f2f2f2"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M255.81023,573.12552a1.18647,1.18647,0,0,1-1.19007,1.19H1.33018a1.19,1.19,0,0,1,0-2.38h253.29A1.18651,1.18651,0,0,1,255.81023,573.12552Z",
    fill: "#ccc"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInProgress);
export default __webpack_public_path__ + "static/media/in-progress.cec038542903fc68e2ff1aa390634312.svg";
export { ForwardRef as ReactComponent };